module.exports = __webpack_public_path__ + "media/flop.c74289db.wav";